import { CalendarHoursProps } from "./CalendarHours";
import { withLabel } from "composants/withLabel";
import CalendarHoursSecondes from "./CalendarHoursSecondes";

export const CalendarHoursSecondeAndLabel = withLabel<CalendarHoursProps>()(CalendarHoursSecondes);

export default CalendarHoursSecondeAndLabel;
